/* ============================================================================
   FEROXMEN kvíz v2 (ED / teljesítmény) - motor. Shopify Horizon ASSET.
   Betölti: feroxmen-quiz2.liquid section -> <script src="{{ 'fxq-quiz2.js' | asset_url }}" defer>
   Config: a #fxq2 konténer data-* attribútumaiból (product-url, webhook).
   CSP-biztos: nincs inline script és nincs inline event-handler.
   ============================================================================ */
(function(){
"use strict";
var root = document.getElementById("fxq2");
if(!root) return;

var PRODUCT_URL   = (root.getAttribute("data-product-url") || "").trim() || "https://feroxmen.hu/products/natural-testosterone-support";
var SHEET_WEBHOOK = (root.getAttribute("data-webhook") || "").trim();
var VARIANT_ID    = (root.getAttribute("data-variant-id") || "").trim();
function _n(attr,fb){ var v=parseInt(root.getAttribute(attr)||"",10); return (isFinite(v)&&v>0)?v:fb; }
var UNIT_PRICE = _n("data-unit-price",11990);
var P1=_n("data-price-1",UNIT_PRICE), P2=_n("data-price-2",UNIT_PRICE*2), P3=_n("data-price-3",UNIT_PRICE*3);
var C1=_n("data-compare-1",23980), C2=_n("data-compare-2",47960), C3=_n("data-compare-3",71940);
var TIER_P=[0,P1,P2,P3], TIER_C=[0,C1,C2,C3];
function fmtFt(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g," ")+" Ft"; }

/* egy görgetősáv: a téma body-ját lezárjuk, csak a .fxq2 konténer görget */
try{ document.documentElement.style.overflow = "hidden"; document.body.style.overflow = "hidden"; }catch(e){}

var IMG = {
  age: {
    "20-29":"https://uploads.convertflow.co/production/websites/80669/S8Bkasi6RWK3wgtGQu39_step-1-1.webp",
    "30-39":"https://uploads.convertflow.co/production/websites/80669/nOAJuLwDT5K2Ys2UZmZf_step-1-2.webp",
    "40-49":"https://uploads.convertflow.co/production/websites/80669/fGmtgRFuS8eKzjaYz9T4_step-1-3.webp",
    "50+":"https://uploads.convertflow.co/production/websites/80669/xEOIjSUzQ1Gcg9ePNYJO_step-1-4.webp"
  },
  busy:"https://uploads.convertflow.co/production/websites/80669/01eBHcrRKOWBlM7wGBwR_87e31061-0601-4461-bdc6-c78a67b50386.webp",
  summary:"https://cdn.shopify.com/s/files/1/0851/8860/8300/files/Outcome_1_-_Summary_of_your_Sexual_Profile.png?v=1764981554"
};

var TICK='<svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var CHK='<svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var SHIELD='<svg viewBox="0 0 24 24" fill="none"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

var state = { a:{}, order:[], pos:0 };

/* ====== KÉRDÉSEK / LÉPÉSEK ====== */
var STEPS = [
  { id:"intro", kind:"intro" },

  { id:"age", kind:"age", key:"age",
    q:"Hány éves vagy?",
    opts:[ {v:"20-29"},{v:"30-39"},{v:"40-49"},{v:"50+"} ] },

  { id:"frus", kind:"single", key:"frus",
    q:"Mi zavar mostanában a legjobban az ágyban?",
    opts:[
      {v:"gyors", l:"Túl gyorsan elmegyek", e:"⏱️"},
      {v:"felall", l:"Nehezen áll fel", e:"⚡"},
      {v:"fenntart", l:"Nehéz fenntartani", e:"〰️"},
      {v:"vagy", l:"Alacsony vágy, kevés kedv", e:"🔋"},
      {v:"mix", l:"Ezek keveréke", e:"🔀"},
      {v:"peak", l:"Semmi", e:"🏔️"}
    ] },

  { id:"anx", kind:"single", key:"anx",
    q:"Szorongsz vagy túlgondolod a dolgot szex előtt vagy közben?",
    sub:"Idegesség, önbizalomhiány, vagy beragadsz a fejedbe.",
    opts:[ {v:"igen", l:"Igen"},{v:"nem", l:"Nem"} ] },

  { id:"impact", kind:"single", key:"impact",
    q:"Mennyire vitte el ez a magabiztosságod vagy a kapcsolatod?",
    opts:[ {v:"sok", l:"Nagyon sokat"},{v:"kicsit", l:"Valamennyit"},{v:"alig", l:"Csak egy kicsit"} ] },

  { id:"when", kind:"single", key:"when",
    q:"Mikor kezdted először észrevenni a változást?",
    opts:[
      {v:"1ev", l:"Több mint egy éve"},
      {v:"idei", l:"Az elmúlt évben"},
      {v:"honap", l:"Az elmúlt pár hónapban"},
      {v:"nemtudom", l:"Nem vagyok biztos benne"}
    ] },

  { id:"goal", kind:"multi", key:"goal",
    q:"Mit szeretnél elérni?",
    sub:"Válassz akárhányat.",
    opts:[
      {v:"tovabb", l:"Tovább bírni az ágyban"},
      {v:"kemeny", l:"Erősebb, keményebb erekció"},
      {v:"libido", l:"Magasabb szexuális vágy"},
      {v:"energia", l:"Több energia egész nap"},
      {v:"magabiztos", l:"Újra magabiztosnak érezni magam"},
      {v:"mind", l:"Mindet a fentiek közül"}
    ] },

  { id:"social", kind:"social" },

  { id:"rel", kind:"single", key:"rel",
    q:"Mi a kapcsolati státuszod?",
    opts:[
      {v:"szingli", l:"Szingli vagy randizom"},
      {v:"parkapcsolat", l:"Kapcsolatban élek"},
      {v:"hazas", l:"Házas vagyok"},
      {v:"bonyolult", l:"Bonyolult"}
    ] },

  { id:"sexlife", kind:"single", key:"sexlife",
    q:"Hogy írnád le a szexuális életed most?",
    opts:[
      {v:"leallt", l:"Gyakorlatilag leállt"},
      {v:"keves", l:"Kevesebb, mint szeretném"},
      {v:"oke", l:"Oké, de nem az igazi"},
      {v:"elegedett", l:"Elégedett vagyok"}
    ] },

  { id:"tried", kind:"tried", key:"tried",
    q:"Mit próbáltál eddig, hogy megoldd?",
    opts:[
      {v:"gyogyszer", l:"Vényköteles tabletta (pl. kék tabletta)"},
      {v:"eletmod", l:"Életmódváltás (edzés, étrend)"},
      {v:"porno", l:"Pornó vagy önkielégítés elhagyása"},
      {v:"semmi", l:"Eddig semmit"},
      {v:"egyeb", l:"Egyéb"}
    ],
    fb:{
      gyogyszer:{c:"warn",i:"!",t:"A tabletta alkalmi mankó",s:"Be kell időzíteni, pár óráig tart, és a háttéren (stressz, alvás, hormonális egyensúly, életmód) nem változtat. A Feroxmen pont ezt a hátteret támogatja, nap mint nap, tervezgetés nélkül."},
      eletmod:{c:"good",i:"✓",t:"Jó irányba indultál",s:"Az alvás, a mozgás és az étkezés az alap, ezt jól látod. De ha a hormonális háttér (kortizol, tesztoszteron) nincs rendben, az életmód önmagában lassan mozdul. Pont ezt a hiányzó láncszemet kell betölteni."},
      porno:{c:"good",i:"✓",t:"Tiszteletre méltó lépés",s:"Sok férfinak segít a fejben, és ez tényleg számít. A fizikai oldalt (véráramlás, hormonszint) viszont önmagában ez nem állítja helyre, ahhoz belülről kell támogatni a szervezetet."},
      semmi:{c:"info",i:"i",t:"Semmi baj, a legtöbben halogatják",s:"A férfiak többsége évekig nem csinál semmit, mert kínos, vagy azt hiszi, ez már a korral jár. A jó hír: minél előbb kezded el támogatni a szervezeted, annál gyorsabban jön vissza a forma."},
      egyeb:{c:"info",i:"i",t:"Értjük",s:"Bármit is próbáltál eddig, a lényeg, hogy a gyökér-okot célozd meg, ne csak a tünetet. A protokollod pont erre épül."}
    } },

  { id:"busy", kind:"inter",
    h:"Se a sűrű napok, se a pénztárcád nem lehet kifogás.",
    body:"A válaszaid alapján összerakunk egy egyszerű, tartható tervet, ami napi fél percbe telik.",
    img:IMG.busy },

  { id:"morning", kind:"why", key:"morning",
    q:"Észrevettél csökkenést a reggeli erekcióban?",
    opts:[ {v:"igen", l:"Igen"},{v:"nem", l:"Nem"},{v:"nemtudom", l:"Nem vagyok biztos"} ],
    why:{ t:"Miért kérdezzük", s:"A reggeli erekció a tesztoszteron és a véráramlás egyik legjobb hétköznapi jelzője. Ha ritkul, az gyakran ugyanarra a hormonális egyensúlyzavarra utal, ami a libidódat és a teljesítményed is húzza." } },

  { id:"stress", kind:"why", key:"stress",
    q:"Milyen gyakran stresszelsz?",
    opts:[ {v:"neha", l:"Néha"},{v:"folyton", l:"Folyamatosan"},{v:"ritkan", l:"Ritkán"},{v:"nemtudom", l:"Nem tudom"} ],
    why:{ t:"Miért kérdezzük", s:"A tartós stressz megemeli a kortizolt, ami leveri a tesztoszteront, elviszi a vágyat, és nehezebbé teszi, hogy ura légy a helyzetnek. Ez az egyik leggyakoribb rejtett kiváltó ok." } },

  { id:"loading", kind:"loading" },

  { id:"summary", kind:"summary" },
  { id:"plan", kind:"chart" },
  { id:"protocol", kind:"protocol" }
];

var NUDGES = [
  { q:"Elszántad magad, hogy végre visszaszerezd a libidód és a teljesítményed?" },
  { q:"Számítottál rá, hogy a stressz ennyit nyom a latban?" },
  { q:"Belefér napi fél perc, hogy visszaszerezd a formád?" }
];

var LOAD_ITEMS = ["Céljaid rögzítése","Válaszaid kiértékelése","Protokoll összeállítása"];

/* ====== MOTOR ====== */
var stage = document.getElementById("fxq2Stage");
var pwrap = document.getElementById("fxq2Pwrap");
var pfill = document.getElementById("fxq2Pfill");

function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }

function progress(){
  var qSteps = STEPS.filter(function(s){ return ["age","single","multi","tried","why"].indexOf(s.kind)>=0; });
  var cur = STEPS[state.pos];
  var done = 0, total = qSteps.length;
  for(var i=0;i<=state.pos && i<STEPS.length;i++){ if(qSteps.indexOf(STEPS[i])>=0 && i<state.pos) done++; }
  var showBar = cur && cur.kind!=="intro";
  pwrap.hidden = !showBar;
  var pct = Math.min(100, Math.round((done/total)*100));
  if(cur && ["summary","chart","protocol","loading"].indexOf(cur.kind)>=0) pct=100;
  pfill.style.width = pct+"%";
}

function clearTimers(){ (state._timers||[]).forEach(function(t){ clearTimeout(t); clearInterval(t); }); state._timers=[]; }
function go(delta){
  state.pos += delta;
  if(state.pos<0) state.pos=0;
  if(state.pos>=STEPS.length) state.pos=STEPS.length-1;
  clearTimers();
  render();
  if(root) root.scrollTop=0;
}
function next(){ go(1); }
function back(){ go(-1); }
function advance(delayMs){
  // dupla-tap (gyors kétszeri koppintás) ne ugorjon két lépést
  if(state._adv) return;
  state._adv = true;
  if(delayMs){ state._timers=(state._timers||[]); state._timers.push(setTimeout(next,delayMs)); }
  else next();
}

function navHtml(showBack){
  return '<div class="nav">'+(showBack?'<button class="back" id="fxq2Back"><svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg> Vissza</button>':'')+'</div>';
}
function wireBack(){ var b=document.getElementById("fxq2Back"); if(b) b.onclick=back; }

function render(){
  var s = STEPS[state.pos];
  progress();
  state._adv = false; // dupla-tap védelem feloldása minden új képernyőn
  if(!s){ return; }
  var fn = ({
    intro:rIntro, age:rAge, single:rSingle, multi:rMulti, tried:rTried,
    social:rSocial, inter:rInter, why:rWhy, loading:rLoading,
    summary:rSummary, chart:rChart, protocol:rProtocol
  })[s.kind];
  stage.innerHTML = '<div class="screen">'+fn(s)+'</div>';
  wireBack();
  var w = ({
    age:wAge, single:wSingle, multi:wMulti, tried:wTried,
    social:wCont, inter:wCont, why:wWhy, loading:wLoading,
    intro:wIntro, summary:wCont, chart:wCont, protocol:wProto
  })[s.kind];
  if(w) w(s);
  if(s.kind==="summary") afterRenderSummary();
}

/* ---- intro ---- */
function rIntro(){
  return '<div class="intro">'
    +'<h1>Derítsd ki, mi viszi el a <span class="o">libidód</span> és a teljesítményed.</h1>'
    +'<p class="sub">Válaszolj pár rövid kérdésre, és összerakjuk a személyre szabott Feroxmen protokollod. Nincs bejelentkezés, nincs kínos beszélgetés.</p>'
    +'<div class="meta"><span>⏱️ <b>~2 perc</b></span><span>🔒 <b>Diszkrét</b></span><span>🌿 <b>Természetes</b></span></div>'
    +'<button class="startbig" id="fxq2Start">Kezdjük <span class="arr">→</span></button>'
    +'</div>';
}
function wIntro(){ var b=document.getElementById("fxq2Start"); if(b) b.onclick=next; }

/* ---- age (képes) ---- */
function rAge(s){
  var o = s.opts.map(function(x){
    var sel = state.a[s.key]===x.v ? " is-sel":"";
    return '<button class="aopt'+sel+'" data-v="'+x.v+'"><img src="'+IMG.age[x.v]+'" alt="'+x.v+'"><span>'+x.v+'</span></button>';
  }).join("");
  return '<h2 class="qtitle">'+esc(s.q)+'</h2><div class="agrid">'+o+'</div>'+navHtml(state.pos>1);
}
function wAge(s){
  Array.prototype.forEach.call(stage.querySelectorAll(".aopt"),function(b){
    b.onclick=function(){ state.a[s.key]=b.getAttribute("data-v"); advance(180); };
  });
}

/* ---- single (auto-advance) ---- */
function optRow(x, sel){
  return '<button class="opt'+(sel?" is-sel":"")+'" data-v="'+x.v+'">'
    +(x.e?'<span class="opt__emoji">'+x.e+'</span>':'')
    +'<span>'+esc(x.l)+'</span><span class="opt__tick">'+TICK+'</span></button>';
}
function rSingle(s){
  var o = s.opts.map(function(x){ return optRow(x, state.a[s.key]===x.v); }).join("");
  return '<h2 class="qtitle">'+esc(s.q)+'</h2>'+(s.sub?'<p class="qsub">'+esc(s.sub)+'</p>':'')
    +'<div class="opts">'+o+'</div>'+navHtml(true);
}
function wSingle(s){
  Array.prototype.forEach.call(stage.querySelectorAll(".opt"),function(b){
    b.onclick=function(){ state.a[s.key]=b.getAttribute("data-v"); advance(180); };
  });
}

/* ---- multi ---- */
function rMulti(s){
  var arr = state.a[s.key]||[];
  var o = s.opts.map(function(x){ return optRow(x, arr.indexOf(x.v)>=0); }).join("");
  return '<h2 class="qtitle">'+esc(s.q)+'</h2>'+(s.sub?'<p class="qsub">'+esc(s.sub)+'</p>':'')
    +'<div class="opts">'+o+'</div>'
    +'<button class="btn btn--cta" id="fxq2Cont" style="margin-top:18px" '+(arr.length?'':'disabled')+'>Folytatom <span class="arr">→</span></button>'
    +navHtml(true);
}
function wMulti(s){
  if(!state.a[s.key]) state.a[s.key]=[];
  Array.prototype.forEach.call(stage.querySelectorAll(".opt"),function(b){
    b.onclick=function(){
      var v=b.getAttribute("data-v"), arr=state.a[s.key], i=arr.indexOf(v);
      if(v==="mind"){ state.a[s.key]= i>=0?[]:s.opts.map(function(x){return x.v;}); }
      else { if(i>=0) arr.splice(i,1); else arr.push(v); var mi=arr.indexOf("mind"); if(mi>=0) arr.splice(mi,1); }
      render();
    };
  });
  var c=document.getElementById("fxq2Cont"); if(c) c.onclick=function(){ advance(0); };
}

/* ---- tried (feltételes visszajelzés) ---- */
function rTried(s){
  var o = s.opts.map(function(x){ return optRow(x, state.a[s.key]===x.v); }).join("");
  var fb="";
  if(state.a[s.key] && s.fb[state.a[s.key]]){
    var f=s.fb[state.a[s.key]];
    fb='<div class="fb fb--'+f.c+'"><div class="fb__t"><span class="ico">'+f.i+'</span>'+esc(f.t)+'</div><span>'+esc(f.s)+'</span></div>';
  }
  return '<h2 class="qtitle">'+esc(s.q)+'</h2><div class="opts">'+o+'</div>'+fb
    +(state.a[s.key]?'<button class="btn btn--cta" id="fxq2Cont" style="margin-top:16px">Folytatom <span class="arr">→</span></button>':'')
    +navHtml(true);
}
function wTried(s){
  Array.prototype.forEach.call(stage.querySelectorAll(".opt"),function(b){
    b.onclick=function(){ state.a[s.key]=b.getAttribute("data-v"); render(); };
  });
  var c=document.getElementById("fxq2Cont"); if(c) c.onclick=function(){ advance(0); };
}

/* ---- why (kérdés + magyarázó doboz) ---- */
function rWhy(s){
  var o = s.opts.map(function(x){ return optRow(x, state.a[s.key]===x.v); }).join("");
  return '<h2 class="qtitle">'+esc(s.q)+'</h2><div class="opts">'+o+'</div>'
    +'<div class="why"><b>'+esc(s.why.t)+'</b><span>'+esc(s.why.s)+'</span></div>'+navHtml(true);
}
function wWhy(s){
  Array.prototype.forEach.call(stage.querySelectorAll(".opt"),function(b){
    b.onclick=function(){ state.a[s.key]=b.getAttribute("data-v"); advance(180); };
  });
}

/* ---- social proof ---- */
function rSocial(){
  return '<div class="social">'
    +'<div style="font-size:42px;margin-bottom:12px">🧬</div>'
    +'<div class="lead" style="font-family:var(--disp);text-transform:uppercase;font-size:clamp(22px,6.2vw,30px);color:#fff;line-height:1.12;margin-bottom:14px">Van megoldás, és egyszerűbb, mint hinnéd.</div>'
    +'<p class="sub">Sok férfinál ugyanaz a minta áll a háttérben: a tartós stressz és a felborult hormonális egyensúly. Mindkettő természetes úton támogatható.</p>'
    +'<p class="sub" style="margin-bottom:22px">A következő pár kérdés segít pontosítani, mi áll nálad a háttérben.</p>'
    +'<button class="btn btn--cta" id="fxq2Cont">Folytatom <span class="arr">→</span></button></div>';
}

/* ---- interstitial ---- */
function rInter(s){
  return '<div class="inter"><h2>'+esc(s.h)+'</h2><p class="body">'+esc(s.body)+'</p>'
    +'<button class="btn btn--cta" id="fxq2Cont">Folytatom <span class="arr">→</span></button>'
    +(s.img?'<img class="qmedia" src="'+s.img+'" alt="">':'')+'</div>';
}
function wCont(){ var c=document.getElementById("fxq2Cont"); if(c) c.onclick=function(){ advance(0); }; }

/* ---- loading + nudge popupok ---- */
function rLoading(){
  var items = LOAD_ITEMS.map(function(t,i){
    return '<div class="cl__item" data-i="'+i+'"><span>'+esc(t)+'</span><span class="cl__pct" data-pct>0%</span></div>';
  }).join("");
  return '<div class="load"><h2>Összerakjuk a protokollod...</h2><p class="sub">A válaszaid alapján, pár másodperc.</p><div class="cl">'+items+'</div></div>';
}
function wLoading(){
  if(!state._logged){ state._logged=true; logToSheet(); }
  var items = Array.prototype.slice.call(stage.querySelectorAll(".cl__item"));
  state._timers=(state._timers||[]);
  var ivs=[];
  function showNudge(n){
    if(n>=NUDGES.length){ finishLoad(); return; }
    var ovl=document.createElement("div"); ovl.className="ovl";
    ovl.innerHTML='<div class="pop"><h3>Egy pillanat</h3><p>'+esc(NUDGES[n].q)+'</p><div class="row"><button class="pbtn pbtn--no">Nem</button><button class="pbtn pbtn--yes">Igen</button></div></div>';
    root.appendChild(ovl);
    function close(){ ovl.remove(); if(ivs[n]) clearInterval(ivs[n]); if(items[n]){ items[n].classList.add("is-done"); var p=items[n].querySelector("[data-pct]"); if(p) p.textContent="✓"; } activate(n+1); state._timers.push(setTimeout(function(){ showNudge(n+1); },400)); }
    ovl.querySelector(".pbtn--yes").onclick=close;
    ovl.querySelector(".pbtn--no").onclick=close;
  }
  function activate(i){
    if(i>=items.length) return;
    items[i].classList.add("is-on");
    var pctEl=items[i].querySelector("[data-pct]"), p=0;
    var iv=setInterval(function(){ p+=Math.random()*22; if(p>=100){p=100;clearInterval(iv);} pctEl.textContent=Math.floor(p)+"%"; },140);
    ivs[i]=iv; state._timers.push(iv);
  }
  activate(0);
  state._timers.push(setTimeout(function(){ showNudge(0); }, 900));
  function finishLoad(){
    items.forEach(function(it){ it.classList.add("is-on","is-done"); var p=it.querySelector("[data-pct]"); if(p) p.textContent="✓"; });
    state._timers.push(setTimeout(next, 650));
  }
}

/* ---- tailoring segédfüggvények ---- */
function derive(){
  var a=state.a;
  var trigger="Alacsony tesztoszteron";
  if(a.stress==="folyton") trigger="Alacsony tesztoszteron + magas kortizol";
  var lvl=18;
  if(a.sexlife==="leallt") lvl=9; else if(a.sexlife==="keves") lvl=17; else if(a.sexlife==="oke") lvl=27; else if(a.sexlife==="elegedett") lvl=34;
  if(a.frus==="peak") lvl=Math.max(lvl,30);
  if(a.impact==="sok") lvl-=4;
  lvl=Math.max(7,Math.min(38,lvl));
  return { trigger:trigger, lvl:lvl };
}
var FRUS_LABEL={gyors:"a túl gyors befejezés",felall:"az erekció beindítása",fenntart:"az erekció fenntartása",vagy:"a lecsökkent vágy",mix:"több gond együtt",peak:"a csúcsformád megtartása"};
var AGE_TXT={"20-29":"húszas éveid","30-39":"harmincas éveid","40-49":"negyvenes éveid","50+":"ötven feletti éveid"};

/* ---- válaszok rögzítése Google Sheetbe ---- */
function labelFor(key,val){
  for(var i=0;i<STEPS.length;i++){ var s=STEPS[i]; if(s.key===key && s.opts){ for(var j=0;j<s.opts.length;j++){ if(s.opts[j].v===val) return s.opts[j].l||s.opts[j].v; } } }
  return val==null?"":val;
}
function logToSheet(){
  if(!SHEET_WEBHOOK) return;
  var a=state.a, d=derive();
  var payload={
    event:"kitoltes",
    age:a.age||"",
    frus:labelFor("frus",a.frus),
    anx:labelFor("anx",a.anx),
    impact:labelFor("impact",a.impact),
    when:labelFor("when",a.when),
    goal:(a.goal||[]).map(function(v){return labelFor("goal",v);}).join(", "),
    rel:labelFor("rel",a.rel),
    sexlife:labelFor("sexlife",a.sexlife),
    tried:labelFor("tried",a.tried),
    morning:labelFor("morning",a.morning),
    stress:labelFor("stress",a.stress),
    level:d.lvl+"%",
    trigger:d.trigger
  };
  try{ fetch(SHEET_WEBHOOK,{method:"POST",mode:"no-cors",keepalive:true,headers:{"Content-Type":"text/plain;charset=utf-8"},body:JSON.stringify(payload)}); }catch(e){}
}

/* ---- summary ---- */
function rSummary(){
  var d=derive();
  // a badge/figyelmeztetés a valós szinthez igazodik, nem mindenkinek "Alacsony"
  var low = d.lvl < 24;
  var badge = low ? '<span class="badge-low">Alacsony</span>' : '<span class="badge-mid">Fejleszthető</span>';
  var warn = low
    ? '<div class="warnbox"><b><span class="dot">!</span> Alacsony szint</b><span>A szexuális egészséged csökkenő jeleket mutat. Ennek leggyakoribb oka a magas kortizol, a lecsökkent tesztoszteron és a gyengülő véráramlás, együtt.</span></div>'
    : '<div class="warnbox"><b><span class="dot" style="background:#e8a13d">i</span> Van még benned tartalék</b><span>Az alapok nálad rendben vannak, de a válaszaid alapján a hormonális egyensúlyod nem a csúcson jár. Pont ilyenkor a leghálásabb rendbe tenni: gyorsan látszik a különbség.</span></div>';
  return '<div class="sheet">'
    +'<div class="skicker">A szexuális profilod összegzése</div>'
    +'<div class="prof__top"><h3>Szexuális egészség szintje</h3>'+badge+'</div>'
    +'<img class="prof__img" src="'+IMG.summary+'" alt="">'
    +'<div class="gauge__bar"><div class="gauge__tag" id="fxq2Gtag" style="left:clamp(50px, 9%, calc(100% - 50px))">A te szinted</div><div class="gauge__dot" id="fxq2Gdot" style="left:9%"></div></div>'
    +'<div class="gauge__ends"><span>Alacsony</span><span>Mérsékelt</span><span>Jó</span><span>Csúcsforma</span></div>'
    +warn
    +'<div class="cells"><div class="cell"><div class="cell__l">Fejlődési tér</div><div class="cell__v">Magas</div></div><div class="cell warm"><div class="cell__l">⚡ Fő kiváltó ok</div><div class="cell__v">'+esc(d.trigger)+'</div></div></div>'
    +'</div><button class="btn btn--cta" id="fxq2Cont">Folytatom <span class="arr">→</span></button>';
}
function afterRenderSummary(){
  var d=derive();
  var pos=Math.max(9,Math.min(92,d.lvl)); // a címke ne lógjon ki a sáv széléről
  setTimeout(function(){
    var dot=document.getElementById("fxq2Gdot"), tag=document.getElementById("fxq2Gtag");
    if(dot){ dot.style.left=pos+"%"; }
    if(tag){ tag.style.left="clamp(50px, "+pos+"%, calc(100% - 50px))"; }
  },120);
}

/* ---- chart ---- */
function rChart(){
  var bars=[
    {l:"1-2. hét",h:34,c:"#8fb4e6"},
    {l:"3-4. hét",h:56,c:"#a7d99a"},
    {l:"5-7. hét",h:78,c:"#f0d264"},
    {l:"8-9. hét",h:100,c:"#ff8a3d",goal:true}
  ];
  var cols=bars.map(function(b){
    return '<div class="bcol">'+(b.goal?'<div class="goal">'+CHK+' Cél</div>':'')
      +'<div class="bar" style="height:'+b.h+'%;background:'+b.c+';animation-delay:.05s"></div>'
      +'<div class="lab">'+b.l+'</div></div>';
  }).join("");
  return '<h2 class="qtitle">A 63 napos Feroxmen protokollod felépítése.</h2>'
    +'<div class="chart"><div class="bars">'+cols+'</div></div>'
    +'<p class="qsub" style="margin-top:14px">A válaszaid alapján a következő <b style="color:#fff">~63 napban</b> jelentősen javulhat az energiád, a libidód és a teljesítményed az ágyban. Az eredmények egyénenként eltérnek.</p>'
    +'<button class="btn btn--cta" id="fxq2Cont">Kérem a protokollom <span class="arr">→</span></button>';
}

/* ---- mérés: esemény-beacon + UTM ---- */
function addUtm(u){ if(!u) return u; return u + (u.indexOf("?")>=0?"&":"?") + "utm_source=kviz2&utm_medium=quiz&utm_campaign=feroxmen_protokoll"; }
function logEvent(ev,extra){
  if(!SHEET_WEBHOOK) return;
  var p={event:ev}; extra=extra||{}; for(var k in extra) p[k]=extra[k];
  try{
    var body=JSON.stringify(p);
    if(navigator.sendBeacon){ navigator.sendBeacon(SHEET_WEBHOOK, body); }
    else fetch(SHEET_WEBHOOK,{method:"POST",mode:"no-cors",keepalive:true,headers:{"Content-Type":"text/plain;charset=utf-8"},body:body});
  }catch(e){}
}

/* ---- protocol / product: mélyen személyre szabott terv + azonnali kosár ---- */
function diagBullets(){
  // a SAJÁT válaszaiból épül a diagnózis, prioritás szerint max 4 pont
  var a=state.a, out=[];
  if(a.stress==="folyton") out.push({t:"A folyamatos stressz nálad a fő hajtóerő",s:"Magas kortizol mellett a szervezet túlélő üzemmódban van, és a szex hátra sorolódik. Amíg ezt nem fékezed, minden más csak tüneti kezelés."});
  if(a.morning==="igen") out.push({t:"A ritkuló reggeli erekció beszédes jel",s:"Ez a tesztoszteron-szint és a keringés egyik legjobb hétköznapi mutatója. Nem a korod a hiba, hanem az egyensúly, és az visszahozható."});
  else if(a.morning==="nem") out.push({t:"A reggeli forma megvan, ez jó hír",s:"A gépezet működik. Nálad az egyensúlyt és az energiát kell visszahozni, ez a könnyebbik eset."});
  if(a.anx==="igen") out.push({t:"A fejben pörgés önmagát erősíti",s:"A szex körüli szorongás kortizolt emel, a kortizol pedig pont a vágyat és a teljesítményt nyomja el. Ördögi kör, de a testtel együtt a fej is megnyugszik."});
  if(a.when==="1ev"||a.when==="idei") out.push({t:"Nem átmeneti rossz időszak",s:(a.when==="1ev"?"Több mint egy éve":"Már hónapok óta")+" tart, tehát berögzült egyensúlyhiányról van szó. Magától ritkán fordul vissza, következetes protokollra viszont jól reagál."});
  if(out.length<4 && a.tried==="gyogyszer") out.push({t:"A tabletta eddig csak a tünetet fedte el",s:"Pár órára megoldotta, de a hátteret (kortizol, tesztoszteron, keringés) nem kezelte. Ezért nem lett tőle jobb az alapforma."});
  if(out.length<4 && a.sexlife==="leallt") out.push({t:"Az, hogy leállt, nem végállapot",s:"A vágy a hormonális egyensúllyal együtt szokott visszatérni. Előbb a test, aztán a kedv, végül a rutin."});
  if(out.length<2) out.push({t:"Az alapok rendben, a tartalék hiányzik",s:"A válaszaid alapján nem baj van, hanem tartalék nincs: a forma ingadozik, ahelyett hogy stabilan hozná, amit tudsz."});
  return out.slice(0,4);
}
function planSteps(){
  var a=state.a, goals=a.goal||[];
  var has=function(g){ return goals.indexOf(g)>=0 || goals.indexOf("mind")>=0; };
  var steps=[];
  steps.push({n:"1",t:"Napi 5 kapszula Feroxmen, reggel, étkezés után",s:(a.stress==="folyton"||a.anx==="igen")?"Reggel indítva az ashwagandha (stresszes időszakokban hagyományosan használt adaptogén) egész napra veled van, a cink pedig hozzájárul a normál tesztoszteronszint fenntartásához. Fél perc, kávé mellé.":"8 hatóanyag egy adagban: a cink a normál tesztoszteronszint fenntartásához, a magnézium a fáradtság csökkentéséhez járul hozzá. Fél perc reggelente, ennyi a dolgod belőle."});
  if(a.stress==="folyton"||a.anx==="igen") steps.push({n:"2",t:"Esti kortizol-zár",s:"Lefekvés előtt 30 perccel képernyő le, cél a 7 óra alvás. A tesztoszteron döntő része alvás közben termelődik: ha ezt megadod, a protokoll kétszer olyan gyorsan dolgozik."});
  else steps.push({n:"2",t:"Heti 2-3 rövid erősítő edzés vagy tempós séta",s:"A nagy izomcsoportok terhelése a legerősebb természetes jel a szervezetnek, hogy tesztoszteronra van szükség. Nem kell edzőterem, 20-30 perc elég."});
  if(has("tovabb")||a.frus==="gyors") steps.push({n:"3",t:"Vedd le a nyomást az ágyban",s:"Lassíts, végy levegőt, és ne eredményt akarj. A kontroll a testtel együtt épül vissza, a protokoll alatt hétről hétre könnyebb lesz."});
  else if(a.frus==="felall"||a.frus==="fenntart"||has("kemeny")) steps.push({n:"3",t:"Napi 20 perc mozgás a keringésért",s:"Tempós séta, lépcső, bármi, ami megdolgoztatja a szíved. Amit a keringés pumpál, azt érzed ott lent is."});
  else if(a.frus==="vagy"||has("libido")) steps.push({n:"3",t:"Heti egy nyomásmentes, közös este",s:"A vágynak tér kell, nem elvárás. Ahogy az energia visszatér, a kedv magától utána jön, ne siettesd, csak add meg neki a lehetőséget."});
  else steps.push({n:"3",t:"Egy fix lefekvési idő, hét minden napján",s:"Az energia és a hormonális ritmus a rendszerességből él. Ez a legolcsóbb teljesítményfokozó, amit ismerünk."});
  return steps;
}
function timelineRows(){
  var a=state.a, goals=a.goal||[];
  var has=function(g){ return goals.indexOf(g)>=0 || goals.indexOf("mind")>=0; };
  var main = has("kemeny")||a.frus==="felall"||a.frus==="fenntart" ? "a hálószobai formád stabilizálódik"
           : (has("tovabb")||a.frus==="gyors" ? "nő a kontroll és a kitartás az ágyban"
           : (has("libido")||a.frus==="vagy" ? "a vágy érezhetően visszatér" : "a formád stabilan a régi szintre áll"));
  return [
    {w:"1-2. hét",s:"Mélyebb alvás, kevesebb délutáni leeresztés. A kortizolgát elkezd dolgozni."},
    {w:"3-4. hét",s:"Több reggeli energia, éledező kedv. Sokan itt veszik észre az első különbséget."},
    {w:"6-9. hét",s:"A válaszaid alapján nálad itt a cél: "+main+"."}
  ];
}
function recQty(){
  var a=state.a;
  if(a.when==="1ev"||a.when==="idei") return 3;   // régóta tart: teljes 90 napos protokoll
  if(a.when==="honap") return 2;
  return 3;
}
function prodFeats(){
  var a=state.a, out=[];
  if(a.stress==="folyton"||a.anx==="igen") out.push({t:"Stressz-front: ashwagandha + taurin",s:"Az ashwagandha évszázadok óta a stresszes időszakok adaptogénje. Azért van a Feroxmenben, hogy ne a kortizol vezesse a napjaidat, mert nálad most az ül a formádon."});
  out.push({t:"Tesztoszteron-front: cink + D-vitamin + görögszéna",s:"A cink hozzájárul a vér normál tesztoszteronszintjének fenntartásához. Nem varázslat: alapanyag, amiből a szervezeted minden nap dolgozik, és amiből "+(a.age==="50+"||a.age==="40-49"?"a korral egyre kevesebb jut":"stressz alatt egyre kevesebb jut")+"."});
  out.push({t:"Energia-front: magnézium + shilajit + ginzeng",s:"A magnézium hozzájárul a fáradtság és a kifáradás csökkentéséhez. Ez az, amit a legtöbben már az első hetekben megéreznek."});
  out.push({t:"Ami NINCS benne",s:"Töltőanyag, titkos keverék, hormon. USA gyártás, független laborteszt, napi 5 kapszula. Ennyi az egész protokoll."});
  return out.slice(0,4);
}
var TESTIS=[
  {a:"50+",t:"forma",n:"László, 57",q:"Az elején szkeptikus voltam, ötven felett az ember már mindent hallott. A második doboz közepén ott volt újra a reggeli forma, és a feleségem is megérezte a különbséget."},
  {a:"50+",t:"tabletta",n:"Ferenc, 61",q:"A kék tablettát utáltam, mert tervezni kellett vele. Ez más: napi rutin, nem az alkalomra készülök, hanem úgy általában lettem jobban."},
  {a:"50+",t:"energia",n:"István, 55",q:"Nem csoda történt, csak visszajött az erőm. Délután nem ülök le, este nem alszom el a tévé előtt. A többi ebből jött magától."},
  {a:"40-49",t:"forma",n:"Gábor, 44",q:"Két hét után vettem észre, hogy nem esek szét délutánra. A harmadik dobozt viszem, és eszem ágában sincs abbahagyni."},
  {a:"40-49",t:"libido",n:"Péter, 46",q:"A kedv jött vissza először, aztán az önbizalom. A párom szerint megint az vagyok, akivel annak idején összejött."},
  {a:"40-49",t:"energia",n:"Zoltán, 43",q:"Sok stressz, két gyerek, vállalkozás. Nem hittem, hogy fél perc reggelente bármit változtat. Három hónap után már nem kérdés."},
  {a:"30-39",t:"forma",n:"Ádám, 34",q:"Harmincévesen ciki volt bevallani, hogy gond van. Két doboz után nem téma többé, és nekem ez a lényeg."},
  {a:"20-29",t:"forma",n:"Bence, 27",q:"A fejemben volt a gond fele, a másik fele a kimerültségben. Mindkettőn segített, a barátnőm igazolja."}
];
function themeOf(){
  var a=state.a, g=a.goal||[];
  if(a.tried==="gyogyszer") return "tabletta";
  if(a.frus==="vagy"||g.indexOf("libido")>=0) return "libido";
  if(a.stress==="folyton"&&(a.frus==="peak"||g.indexOf("energia")>=0)) return "energia";
  return "forma";
}
function pickTestis(){
  var age=state.a.age||"40-49", th=themeOf();
  var same=TESTIS.filter(function(x){return x.a===age;});
  if(!same.length) same=TESTIS.slice();
  same.sort(function(x,y){ return (y.t===th?1:0)-(x.t===th?1:0); });
  return same.slice(0,2);
}
function mainOutcome(){
  var a=state.a, g=a.goal||[];
  var all=g.indexOf("mind")>=0;
  if(a.frus==="vagy"||(!all&&g.indexOf("libido")>=0)) return "magasabb vágyról";
  if(a.frus==="gyors"||(!all&&g.indexOf("tovabb")>=0)) return "nagyobb kontrollról az ágyban";
  if(a.frus==="felall"||a.frus==="fenntart"||a.frus==="mix"||all||g.indexOf("kemeny")>=0) return "stabilabb formáról az ágyban";
  return "több energiáról";
}
var HEADS={
  "50+":"Ötven felett a tesztoszteronszint évről évre csúszik. Ez nem ítélet: egyensúly kérdése. És az egyensúly visszaállítható.",
  "40-49":"Negyven után a hormonális egyensúly borul meg először. Nem a korod a hiba, a háttér az. És a háttér rendbe tehető.",
  "30-39":"Harmincasként ritkán a tested a gond: a kortizol az. A stressz leveri a tesztoszteront, és ezt érzed az ágyban.",
  "20-29":"Húszasként szinte sosem a tested a gond: a stressz és a kimerültség az. Ez a leggyorsabban fordítható helyzet."
};
function frusSent(trg){
  var t=trg.toLowerCase();
  return ({
    mix:"Nálad nem egy gond van: több minden csúszik el egyszerre. Ez a felborult egyensúly kézjegye ("+t+"), ezért az alapoknál kell megfogni.",
    gyors:"A fő gondod a korai befejezés. A háttérben nálad "+t+" áll.",
    felall:"A fő gondod a beindulás. A háttérben nálad "+t+" áll.",
    fenntart:"A fő gondod a forma megtartása. A háttérben nálad "+t+" áll.",
    vagy:"A fő gondod az eltűnt kedv. A háttérben nálad "+t+" áll.",
    peak:"Éles gondod nincs: a célod a csúcsforma megtartása, mielőtt a "+t+" utolérne."
  })[state.a.frus]||("A háttérben nálad "+t+" áll.");
}
function timelineP(){
  var a=state.a, g=a.goal||[], all=g.indexOf("mind")>=0;
  var w1="Mélyebb alvás, kevesebb délutáni leeresztés"+((all||g.indexOf("energia")>=0)?", és megjön az első plusz energia":"")+".";
  var w2=(a.frus==="vagy"||all||g.indexOf("libido")>=0)?"A kedv érezhetően éledezik, több reggeli forma. Sokan itt veszik észre az első igazi különbséget.":"Több reggeli energia, magabiztosabb alap. Sokan itt veszik észre az első igazi különbséget.";
  var w3="A válaszaid alapján nálad itt áll össze: "+mainOutcome().replace(/ról$|ről$/,"")+".";
  return [{w:"1. héttől",s:w1},{w:"3-4. hét",s:w2},{w:"6-9. hét",s:w3}];
}
var ING2=[["Görögszéna","tesztoszteron-front"],["Ashwagandha","stressz-front"],["Shilajit","energia-front"],["D-aszparaginsav","tesztoszteron-front"],["Cink","normál tesztoszteronszint"],["Magnézium","fáradtság ellen"],["D + K-vitamin","alapok"],["Ginzeng","lendület"]];
function rProtocol(){
  var a=state.a, d=derive();
  var head=HEADS[a.age]||HEADS["40-49"];
  var diags=diagBullets().slice(0,3).map(function(x){return '<div class="diag"><span class="diag__ico">!</span><div><b>'+esc(x.t)+'</b><span>'+esc(x.s)+'</span></div></div>';}).join("");
  var feats=prodFeats().map(function(x){return '<div class="feat">'+SHIELD+'<div><b>'+esc(x.t)+'.</b> <span>'+esc(x.s)+'</span></div></div>';}).join("");
  var tl=timelineP().map(function(x){return '<div class="tl"><span class="tl__w">'+esc(x.w)+'</span><span class="tl__s">'+esc(x.s)+'</span></div>';}).join("");
  var testis=pickTestis().map(function(x){return '<div class="tmini"><b>'+esc(x.n)+':</b> "'+esc(x.q)+'"</div>';}).join("");
  var ing=ING2.map(function(x){return '<div class="ing__item"><span class="ing__n">'+esc(x[0])+'</span><span class="ing__d">'+esc(x[1])+'</span></div>';}).join("");
  var rq=recQty();
  var qty=[1,2,3].map(function(q){
    var lab=q===1?"Próba":(q===2?"Ráerősítés":"Teljes protokoll");
    var now=fmtFt(TIER_P[q]), was=TIER_C[q]>0?'<span class="qc__was">'+fmtFt(TIER_C[q])+'</span>':'';
    var extra=q===3?'<span class="qc__gift">+ 3 ajándék + ingyen szállítás</span>':'';
    return '<button class="qcard'+(q===rq?' is-sel':'')+'" data-q="'+q+'">'
      +(q===rq?'<span class="qc__badge">A TE PROTOKOLLOD</span>':'')
      +'<span class="qc__l">'+q+' doboz</span><span class="qc__d">'+lab+' · '+(q*30)+' nap</span>'
      +'<span class="qc__p">'+now+' '+was+'</span>'+extra+'</button>';
  }).join("");
  return '<div class="sheet proto">'
    +'<div class="skicker">A Te Feroxmen protokollod</div>'
    +'<h2>'+esc(head)+'</h2>'
    +'<div class="psumm">'+esc(frusSent(d.trigger))+' Pontosan erre a helyzetre raktuk össze a Feroxment.</div>'
    +diags
    +'<div class="psec" style="margin-top:20px">A megoldásod: a Feroxmen</div>'
    +'<img class="prod__img" src="https://cdn.shopify.com/s/files/1/0968/5411/4648/files/feroxmen-termesztes-tesztoszteron-fokozo-1174718.png?v=1777722029" alt="Feroxmen" loading="lazy">'
    +'<div class="psumm">Természetes tesztoszteron-támogató, <b>8 hatóanyag</b> klinikailag használt adagban. Nem tabletta, amit időzíteni kell: napi rutin, ami ott dolgozik, ahol nálad a gond ül.</div>'
    +feats
    +'<div class="ing">'+ing+'</div>'
    +'<div class="proofrow"><span class="stars">★★★★★</span><span><b>4,8/5</b> · <b>3 683</b> vélemény</span></div>'
    +'<div class="proofline">A felhasználók <b>91%-a</b> '+esc(mainOutcome())+' számolt be <b>90 napon belül</b>.</div>'
    +testis
    +'<div class="psec" style="margin-top:18px">Mire számíthatsz</div><div class="tlwrap">'+tl+'</div>'
    +'<div class="psec" style="margin-top:20px">Válaszd ki a protokollod</div>'
    +'<div class="qsel">'+qty+'</div>'
    +'<div class="commit">A tervem: <b id="fxq2Commit">'+rq+' doboz · '+(rq*30)+' nap · napi 5 kapszula</b></div>'
    +'<ul class="gifts"><li>'+CHK+' Pénzvisszafizetési garancia, kérdések nélkül</li><li>'+CHK+' Diszkrét csomagolás, jelöletlen doboz</li><li>'+CHK+' Hazai raktár, gyors szállítás</li></ul>'
    +'</div>'
    +'<button class="btn btn--cta" id="fxq2Atc">Kosárba teszem a protokollom <span class="arr">→</span></button>'
    +'<a class="plink" id="fxq2PLink" href="'+esc(PRODUCT_URL||"#")+'">Előbb megnézem a terméket →</a>'
    +'<p class="disc">A Feroxmen étrend-kiegészítő, nem gyógyszer, és nem helyettesíti a kiegyensúlyozott, változatos étrendet és az egészséges életmódot. Az eredmények egyénenként eltérhetnek. 18+.</p>';
}
function wProto(){
  if(!state._protoSeen){ state._protoSeen=true; logEvent("protokoll_megtekintes",{}); }
  var q=recQty();
  Array.prototype.forEach.call(stage.querySelectorAll(".qcard"),function(b){
    b.onclick=function(){
      q=parseInt(b.getAttribute("data-q"),10)||1;
      Array.prototype.forEach.call(stage.querySelectorAll(".qcard"),function(x){ x.classList.toggle("is-sel",x===b); });
      var c=document.getElementById("fxq2Commit");
      if(c) c.textContent=q+" doboz · "+(q*30)+" nap · napi 5 kapszula";
    };
  });
  var b=document.getElementById("fxq2Atc");
  if(b) b.onclick=function(){
    if(state._buying) return;            // dupla kattintás védelem
    state._buying=true;
    var old=b.innerHTML; b.innerHTML="EGY PILLANAT...";
    logEvent("kosarba",{qty:q});
    // tartalék-út: ha a kosár-hívások bármelyike elhasal, a permalink akkor is célba visz
    var fallback=function(){
      if(VARIANT_ID){ window.location.href="/cart/"+VARIANT_ID+":"+q; }
      else { window.location.href=addUtm(PRODUCT_URL); }
    };
    if(!VARIANT_ID){ fallback(); return; }
    // KosR lánc: kosár ürítése -> tétel hozzáadása -> /apps/checkout (a KosR a kosárból olvas)
    fetch("/cart/clear.js",{method:"POST",credentials:"same-origin"})
      .then(function(){ return fetch("/cart/add.js",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:parseInt(VARIANT_ID,10),quantity:q})}); })
      .then(function(r){
        if(!r||!r.ok) throw new Error("add failed");
        window.location.href="/apps/checkout";
      })
      .catch(function(){ state._buying=false; b.innerHTML=old; fallback(); });
  };
  var pl=document.getElementById("fxq2PLink");
  if(pl){ pl.setAttribute("href",addUtm(PRODUCT_URL)); pl.onclick=function(){ logEvent("termek_link",{qty:q}); }; }
}

// böngésző Vissza gomb: a kvízen belül lépjen vissza, ne dobja el a kitöltést
try{
  history.pushState({fxq2:1},"");
  window.addEventListener("popstate",function(){
    if(state.pos>0){ back(); history.pushState({fxq2:1},""); }
  });
}catch(e){}

render();
})();
